var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "config-group small-12 column d-flex flex-column align-items-center",
    },
    [
      _c(
        "div",
        { staticClass: "config-item w-100 my-auto position-relative" },
        [
          _c(
            "div",
            { staticClass: "config-item__info d-inline-flex" },
            [
              _c("label", { attrs: { for: "auflage_input" } }, [
                _vm._v(_vm._s(_vm._f("translate")("lblAuflage"))),
              ]),
              _vm._v(" "),
              _vm.tooltip
                ? _c("Tooltip", { attrs: { infoText: _vm.tooltip } })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex" }, [
            _c("input", {
              staticClass: "text-center input--auflage",
              attrs: {
                type: "number",
                required: "",
                id: "auflage_input",
                readonly: !_vm.editable,
                step: _vm.option.customValues.schrittgroesseAuflageIndividuell,
              },
              domProps: { value: _vm.individualAuflage },
              on: {
                change: function ($event) {
                  return _vm.checkAndUpdateValue($event)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn--dark ml-1 w-100@until-medium",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.showModal.apply(null, arguments)
                  },
                },
              },
              [_vm._v(_vm._s(_vm._f("translate")("lblPreistabelle")))]
            ),
          ]),
          _vm._v(" "),
          _vm.message
            ? _c(
                "div",
                {
                  staticClass:
                    "text-small mt-prj text-error d-flex line-height-12 option-auflage-error",
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass:
                        "mr-2 svg-icon flex-child-fix position-relative t-1px",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 36 36",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: { cx: "18", cy: "18", r: "18", fill: "#e94d47" },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z",
                          fill: "#fff",
                        },
                      }),
                    ]
                  ),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm._f("translate")("txtNote")) +
                      " " +
                      _vm._s(_vm.message) +
                      "\n      "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("FlyerlineModal", { attrs: { name: "auflagen" } }, [
            _c("div", [
              _c(
                "div",
                {
                  staticClass:
                    "row m-0 show-for-medium bg-secondary text-white",
                },
                [
                  _c(
                    "div",
                    { staticClass: "column font-weight-bold py-prj2" },
                    [_vm._v(_vm._s(_vm._f("translate")("lblAuflage")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "column font-weight-bold py-prj2 border-left border-white",
                    },
                    [
                      _vm._v(_vm._s(_vm._f("translate")("lblPreis")) + " "),
                      _c(
                        "small",
                        { staticClass: "d-block font-weight-light" },
                        [_vm._v(_vm._s(_vm._f("translate")("txtExclVATNoInf")))]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "column font-weight-bold py-prj2 border-left border-white",
                    },
                    [
                      _vm._v(_vm._s(_vm._f("translate")("lblPreis")) + " "),
                      _c(
                        "small",
                        { staticClass: "d-block font-weight-light" },
                        [_vm._v(_vm._s(_vm._f("translate")("txtInclVATNoInf")))]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "column py-prj2 border-left border-white d-flex justify-content-end flex-child-fix",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "btn btn--link btn--prj-min-x" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "sr-only",
                              attrs: { "aria-hidden": "true" },
                            },
                            [_vm._v(_vm._s(_vm._f("translate")("btnChoose")))]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              !_vm.canShowPrices
                ? _c(
                    "div",
                    {
                      staticClass:
                        "p-prj2 pl-5 bg-error text-white line-height-12 position-relative",
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass:
                            "svg-icon flex-child-fix position-absolute error-negative-icon",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 36 36",
                          },
                        },
                        [
                          _c("circle", {
                            attrs: {
                              cx: "18",
                              cy: "18",
                              r: "18",
                              fill: "#fff",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z",
                              fill: "#e94d47",
                            },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n                  " +
                          _vm._s(
                            this.configuratorService.observableData.data
                              .overallStatus.message
                          ) +
                          "\n              "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "v-spacing-child-3@until-medium my-children-1px@medium",
                },
                [
                  _vm._l(_vm.auflagenWithPrice, function (auflage) {
                    return [
                      auflage.status !== "EXCLUDED"
                        ? _c(
                            "div",
                            {
                              key: auflage.id,
                              staticClass:
                                "row flex-column@until-medium ml-0 mr-0 bg-shade-light v-spacing-child-3@until-medium auflagen",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "column py-prj2 py-prj2@medium d-flex align-items-center justify-content-between@until-medium flex-child-fix@until-medium",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "font-weight-bold hide-for-medium",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("translate")("lblAuflage")
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "font-weight-bold-medium" },
                                    [_vm._v(_vm._s(auflage.name))]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "column flex-child-auto@until-medium py-prj py-prj2@medium d-flex align-items-center justify-content-between@until-medium flex-child-fix@until-medium border-left border-white",
                                },
                                [
                                  _vm.canShowPrices
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-between@until-medium w-100",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "font-weight-bold hide-for-medium",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("translate")(
                                                    "lblPreis"
                                                  )
                                                ) + " "
                                              ),
                                              _c(
                                                "small",
                                                {
                                                  staticClass:
                                                    "d-block font-weight-light",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("translate")(
                                                        "txtExclVATNoInf"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(auflage.priceExcl) + " "
                                            ),
                                            auflage.normalPriceExcl
                                              ? _c(
                                                  "s",
                                                  { staticClass: "pl-2" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        auflage.normalPriceExcl
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "column flex-child-auto@until-medium py-prj py-prj2@medium d-flex align-items-center justify-content-between@until-medium flex-child-fix@until-medium border-left border-white",
                                },
                                [
                                  _vm.canShowPrices
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-between@until-medium w-100",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "font-weight-bold hide-for-medium",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("translate")(
                                                    "lblPreis"
                                                  )
                                                ) + " "
                                              ),
                                              _c(
                                                "small",
                                                {
                                                  staticClass:
                                                    "d-block font-weight-light",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("translate")(
                                                        "txtInclVATNoInf"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(auflage.priceIncl) + " "
                                            ),
                                            auflage.normalPriceIncl
                                              ? _c(
                                                  "s",
                                                  { staticClass: "pl-2" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        auflage.normalPriceIncl
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "column py-prj2 d-flex align-items-center border-left border-white d-flex justify-content-end flex-child-fix",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn--prj-min-x w-100@until-medium",
                                      attrs: { href: "javascript:void(0)" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.select(auflage)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm._f("translate")("btnChoose"))
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "text-xsmall mt-prj2" }, [
                _vm._v(_vm._s(_vm._f("translate")("lblPreisMitKonf"))),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }